import auth from "../../auth/auth-helper";

const LoanRequestsList = async (signal, credentials) => {
  try {
    let response = await fetch(
      process.env["REACT_APP_API_HOST"] +
        "/api/" +
        auth.getuserType() +
        "/loans/requested",
      {
        method: "GET",
        signal: signal,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "x-access-token": credentials,
        },
      },
    );
    return await response.json();
  } catch (err) {
    console.log(err);
  }
};

const ApproveRequest = async (credentials, id) => {
  console.log(id);
  try {
    let response = await fetch(
      process.env["REACT_APP_API_HOST"] +
        "/api/" +
        auth.getuserType() +
        "/loans/requested/" +
        id,
      {
        method: "PUT",

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "x-access-token": credentials,
        },
      },
    );
    return await response.json();
  } catch (err) {
    console.log(err);
  }
};

const RejectRequest = async (credentials, id) => {
  console.log(id);
  try {
    let response = await fetch(
      process.env["REACT_APP_API_HOST"] +
        "/api/" +
        auth.getuserType() +
        "/loans/rejected/" +
        id,
      {
        method: "PUT",

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "x-access-token": credentials,
        },
      },
    );
    return await response.json();
  } catch (err) {
    console.log(err);
  }
};

export { LoanRequestsList, ApproveRequest,RejectRequest };
